import { GetMetersResponseSchema, type GetMetersResponse } from '@weft/api-definition';
import { validateNotEmptyObject } from '@weft/utils';
import type { UseQueryOptions } from 'react-query';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';

export function useMeters(options?: Omit<UseQueryOptions<GetMetersResponse, unknown, GetMetersResponse, string[]>, 'queryKey' | 'queryFn'>) {
  const metersQuery = useQuery(
    ['meters'],
    async () => {
      const api = getPrivateApi();
      const getMetersResponse = await api.getMeters();

      return GetMetersResponseSchema.parse(getMetersResponse);
    },
    { suspense: true, ...options },
  );
  
  validateNotEmptyObject(metersQuery.data, 'Meters');

  return metersQuery;
}